import { Language } from '@openeducation/oe-it-shared-types';

const getSeparator = (lang: Language) => {
  switch (lang) {
    case Language.ES:
    case Language.VI:
    case Language.PT:
      return '.';
    case Language.EN:
    case Language.TR:
    default:
      return ',';
  }
};

export const addThousandSeparator = (num: number | string, lang: Language) => {
  const separator = getSeparator(lang);

  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};
